/**
 * Forward to a Friend — client for the public referral capture edge function.
 *
 * Mirrors EventLandingPage's public-edge-fn pattern: raw fetch to
 * `${VITE_SUPABASE_URL}/functions/v1/<fn>` with Content-Type only (the function is
 * verify_jwt=false, so no auth session/headers are required).
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const FN_URL = `${SUPABASE_URL}/functions/v1/forward-to-a-friend-capture`;

export interface ResolveReferralResult {
  valid: boolean;
  eventTitle?: string | null;
  joinUrl?: string;
}

export interface CaptureReferralResult {
  ok: boolean;
  status?: "captured" | "already_referred";
  error?: string;
  joinUrl?: string;
  email?: string;
}

export interface CaptureReferralInput {
  /** Referral token (link path) OR referredByMemberNo (verbal path) — at least one required. */
  token?: string;
  referredByMemberNo?: string;
  email: string;
  firstName: string;
  lastName: string;
}

async function postReferral<T>(payload: Record<string, unknown>): Promise<T> {
  const res = await fetch(FN_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return (await res.json()) as T;
}

export async function resolveReferral(
  token: string,
): Promise<ResolveReferralResult> {
  return postReferral<ResolveReferralResult>({ action: "resolve", token });
}

export async function captureReferral(
  input: CaptureReferralInput,
): Promise<CaptureReferralResult> {
  return postReferral<CaptureReferralResult>({ action: "capture", ...input });
}
